export default "__VITE_ASSET__chcr0yQK__"